import React from 'react';
import { ContentCard } from '../common/ContentCard';
import { formatJobDateCell } from '../../utils/jobDateDisplay';
import type { JobType } from '../../utils/types';

interface JobProductionDatesCardProps {
  glass_arrival_date?: string | null;
  manufacture_date?: string | null;
  potential_delivery_date?: string | null;
  job_type?: JobType | null;
}

const DATE_ROWS: Array<{
  key: 'gad' | 'dom' | 'pdd';
  label: string;
  fullName: string;
  field: 'glass_arrival_date' | 'manufacture_date' | 'potential_delivery_date';
  withTime: boolean;
  hideForGc?: boolean;
}> = [
  {
    key: 'gad',
    label: 'GAD',
    fullName: 'Glass Arrival Date',
    field: 'glass_arrival_date',
    withTime: false,
    hideForGc: true,
  },
  {
    key: 'dom',
    label: 'DOM',
    fullName: 'Date of Manufacture',
    field: 'manufacture_date',
    withTime: false,
  },
  {
    key: 'pdd',
    label: 'PDD',
    fullName: 'Potential Delivery Date',
    field: 'potential_delivery_date',
    withTime: true,
  },
];

export const JobProductionDatesCard: React.FC<JobProductionDatesCardProps> = ({
  glass_arrival_date,
  manufacture_date,
  potential_delivery_date,
  job_type,
}) => {
  const values = {
    glass_arrival_date,
    manufacture_date,
    potential_delivery_date,
  };

  return (
    <ContentCard title="Production Dates" subtitle="GAD, DOM, and PDD for this job">
      <dl className="space-y-3">
        {DATE_ROWS.filter((row) => !(row.hideForGc && job_type === 'gc')).map((row) => (
          <div key={row.key} className="flex items-baseline justify-between gap-3">
            <dt className="text-sm text-gray-600 shrink-0" title={row.fullName}>
              <span className="font-medium text-gray-800">{row.label}</span>
              <span className="hidden sm:inline text-gray-500"> — {row.fullName}</span>
            </dt>
            <dd className="text-sm text-gray-900 text-right">
              {formatJobDateCell(values[row.field], row.withTime)}
            </dd>
          </div>
        ))}
      </dl>
    </ContentCard>
  );
};
